import React from 'react';
import { DetailSection, DetailRow, LinkChip, ChipGrid, StatusBadge } from './detail-primitives';
import EditStudentPhoneButton from '../EditStudentPhoneButton';
import { guardianName, guardianPhone } from '../../lib/studentContact';

const StudentDetail = ({ data, onOpen }) => {
  const refresh = () => {
    // The modal owns its own data load on mount via the entity id;
    // simplest refresh is to nudge React with a no-op state ping
    // through window.location — but a full window.location.reload()
    // would close the search modal stack. Instead we trust the
    // EditStudentPhoneButton's `success` state to confirm the change
    // and rely on the next time the admin re-opens the card to see
    // the updated value (the card always fetches fresh data on open).
  };
  // Mar 2 2026 — bug fix: use ONLY the canonical `student_profile_id`
  // from the global-search payload. Previously we fell back to
  // `data.id` when the field was missing, but `data.id` on a
  // global-search "student" hit is the USER id (`users._id`), not the
  // `student_profiles._id` that the /api/admin/student-phone/{id}
  // endpoint expects — so the silent fallback always produced
  // "ملف الطالب غير موجود" (404) on save. Backend has been updated to
  // always return `student_profile_id`; if it's ever missing for some
  // reason we now hide the edit button entirely instead of sending a
  // wrong id.
  const studentProfileId = data.student_profile_id;
  const currentPhone = data.phone_number || data.whatsapp_number || '';
  const guardianContactName = guardianName(data);
  const guardianContactPhone = guardianPhone(data);
  return (
  <div className="space-y-3" data-testid="student-detail-body">
    <DetailSection title="بطاقة الطالب">
      <DetailRow label="الاسم" value={data.full_name} testId="student-full-name" />
      <DetailRow label="الحالة" value={<StatusBadge status={data.status} />} />
      <DetailRow label="كود الطلب" value={data.application_code} testId="student-application-code" />
      <DetailRow label="العمر" value={data.age} />
      <DetailRow label="الجنس" value={data.gender} />
      <DetailRow label="المدينة" value={data.city} />
    </DetailSection>

    <DetailSection title="التواصل">
      <DetailRow
        label="جوال الطالب"
        value={
          <span className="inline-flex items-center gap-2">
            <span>{data.phone_number || '—'}</span>
            {studentProfileId && (
              <EditStudentPhoneButton
                studentProfileId={studentProfileId}
                currentPhone={currentPhone}
                studentName={data.full_name}
                onSaved={refresh}
                testIdPrefix="globalsearch-edit-phone"
                iconOnly
              />
            )}
          </span>
        }
      />
      <DetailRow label="واتساب" value={data.whatsapp_number} />
      <DetailRow label="البريد" value={data.email} />
      <DetailRow label="تاريخ التسجيل" value={(data.joined_at || '').slice(0, 10)} />
    </DetailSection>

    <DetailSection title="المسار الأكاديمي">
      <DetailRow label="البرنامج" value={data.program_name} />
      <DetailRow label="المستوى" value={data.level_name} />
    </DetailSection>

    <DetailSection title="ولي الأمر">
      <DetailRow label="اسم ولي الأمر" value={guardianContactName} testId="global-student-guardian-name" />
      <DetailRow label="جوال ولي الأمر" value={guardianContactPhone} testId="global-student-guardian-phone" />
    </DetailSection>

    <DetailSection title={`القاعات (${(data.classrooms || []).length})`}>
      <ChipGrid empty="الطالب غير مُسجَّل في أي قاعة بعد.">
        {(data.classrooms || []).map((c) => (
          <LinkChip
            key={c.id}
            kind="classroom"
            id={c.id}
            onOpen={onOpen}
            label={c.classroom_name || c.classroom_code || 'قاعة'}
            sub={[c.teacher_name, c.schedule, c.status].filter(Boolean).join(' • ')}
            testId={`student-classroom-link-${c.id}`}
          />
        ))}
      </ChipGrid>
    </DetailSection>
  </div>
  );
};

export default StudentDetail;
